import { GetListParams, GetListResult } from 'react-admin';
import { getClientApi } from 'src/data-communication';
import { PositionDto } from 'src/dtos';
import { mapPositionListDtoToModel } from 'src/mappers';
import { Position, Quote } from 'src/models';

import { getQuoteList } from './quote.provider';

const clientApi = getClientApi();

export const getPositionList = async (params: GetListParams): Promise<GetListResult<Position>> => {
  const { accountId } = params.meta;
  let positions: Position[] = [];
  const { data } = await clientApi.position.list({
    params: {
      accountId,
    },
  });

  const symbols: string[] = data.map((aPositionDto: PositionDto) => aPositionDto.Symbol);

  let snapQuotes: Quote[] = [];

  try {
    if (symbols.length) {
      const response = await getQuoteList({
        meta: {
          symbols,
        },
      });
      snapQuotes = response.data;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching quote media.');
    // eslint-disable-next-line no-console
    console.error(error);
  }

  const { data: privateQuotes } = await clientApi.privateQuote.list({
    queryParams: {},
  });

  return {
    data: mapPositionListDtoToModel(data, snapQuotes, privateQuotes),
    total: positions.length,
  };
};
